/**
 * PushNotificationsBootstrap
 *
 * Mounted once inside the Router so it can use `useNavigate` for deep-link
 * routing from notification taps. It does NOT prompt the user — it only:
 *   - refreshes the existing Web Push subscription's `last_seen_at` if any
 *   - boots Capacitor native push (iOS / Android) where applicable
 *   - subscribes to Electron-shown notification clicks for deep linking
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePushSubscription } from "@/hooks/usePushSubscription";
import { initNativePush } from "@/lib/native-push";
import { onElectronNotificationClick } from "@/lib/electron-bridge";

export function PushNotificationsBootstrap() {
  usePushSubscription();
  const navigate = useNavigate();

  useEffect(() => {
    initNativePush((link) => {
      try {
        navigate(link);
      } catch {
        window.location.assign(link);
      }
    });

    const off = onElectronNotificationClick((link) => {
      try {
        navigate(link);
      } catch {
        window.location.assign(link);
      }
    });
    return off;
  }, [navigate]);

  return null;
}
